import { ReactiveElement } from "@nrk/reactive-element";
import { FocusWithinController } from "@nrk/element-focus-within-controller";
import { getElementOfType } from "../utils/dom.js";
import platform from "../utils/platform.js";
class VolumeElement extends ReactiveElement {
  static get reactiveProperties() {
    return {
      ...super.reactiveProperties,
      muted: Boolean,
      volume: Number,
      //used by FocusWithinController
      focusWithin: Boolean
    };
  }
  /** Flag indicating that audio is muted  (shadowed Player property) */
  muted = false;
  /** The audio volume level from 0 to 1  (shadowed Player property) */
  volume = 1;
  /** used by FocusWithinController */
  focusWithin = false;
  focusWithinController;
  /** The PlayerElement parent instance */
  player;
  _unshadowProperties;
  constructor() {
    super();
    this.focusWithinController = new FocusWithinController(this, {
      onChanged: () => {
        this.focusWithin = this.focusWithinController.value;
        this.classList.toggle("focus-within", this.focusWithin);
      }
    });
  }
  readyCallback() {
    super.readyCallback();
    this.player = getElementOfType(this);
    this._unshadowProperties = this.player.shadowProperties(["muted", "volume"], this);
    this.addEventListener("wheel", this, platform.supportsPassiveEvents ? { passive: false } : void 0);
    this.muted = this.player.muted;
    this.volume = this.player.volume;
  }
  disconnectedCallback() {
    this.removeEventListener("wheel", this);
    this._unshadowProperties?.();
    this.player = null;
    super.disconnectedCallback();
  }
  handleEvent(event) {
    if (event.type === "wheel" && event.target?.nodeName === "INPUT") {
      event.preventDefault();
      event.stopPropagation();
      const target = event.target;
      const mouseWheelEvent = event;
      if (mouseWheelEvent.deltaY == 0) {
        return;
      }
      const currentVolume = this.muted ? 0 : this.volume;
      const change = mouseWheelEvent.deltaY > 0 ? -0.1 : 0.1;
      const newVolume = Math.max(Math.min(currentVolume + change, 1), 0);
      if (newVolume === currentVolume) {
        return;
      }
      target.value = String(newVolume * 100);
      target.dispatchEvent(new Event("change", { cancelable: true, bubbles: true }));
    }
  }
}
export {
  VolumeElement
};
